import React, {useContext, useEffect, useState} from 'react'
import {Divider, Button} from "antd";
import {Table} from "react-bootstrap";
import RecipeProductionHeaders from "./RecipeProductionHeaders";
import ProductionListRows from "./ProductionListRows";
import {RecipeConText} from "../../../../../context/RecipeContext";
import {getAllProductionCost} from "../../../../../services/serviceProductionCost";

const RecipeProductionCost = () => {

    const [rowCount, setRowCount] = useState(0)
    const [startReading, setStartReading] = useState(false)

    const {productionData} = useContext(RecipeConText)
    const [productionCosts, setProductionCosts] = productionData


    useEffect(() => {
        getAllProductionCost()
            .then(({data}) => {
                   let  mockProductionData = Object.assign({}, productionCosts)
                    data.map((item, index) => {
                        mockProductionData[index] = item
                    })
                setRowCount(data.length)
                setProductionCosts(mockProductionData)
            })
    }, [])

    const handleNewRow = () => {
        const obj = {}
        let mockProduction = Object.assign({}, productionCosts)
        mockProduction[rowCount] = obj
        setProductionCosts(mockProduction)
        setRowCount(rowCount + 1)
        setStartReading(true)
    }

    return (
        <React.Fragment>
            <div style={{marginTop: '16px'}}>
                <h3>Üretim Maliyeti Listesi</h3>
                <Divider/>
            </div>
            <Button
                type={'link'}
                style={{marginBottom: '16px'}}
                onClick={handleNewRow}
            >
                Yeni Ekle
            </Button>
            <Table
                className={'recipe-table'}
                responsive
            >
                <thead>
                <tr>
                    <RecipeProductionHeaders/>
                </tr>
                </thead>
                <tbody>
                {
                        Object.keys(productionCosts).map(key => {
                            let item = productionCosts[key]
                            return <ProductionListRows key={key} id={key} row={item} />
                        })
                }
                </tbody>
            </Table>
        </React.Fragment>
    )
}
export default RecipeProductionCost